import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import MultiSelectOptionT from '@/Controls/MultiSelectOption';

export default class MultiSelectOptionsBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.multiSelectOptions = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let MultiSelectOption = ComponentManager.getControl<typeof MultiSelectOptionT>('MultiSelectOption');

                let multiSelect = $(element);
                let options = valueAccessor();
                let parent = options.parent;
                let items = options.options;

                function onOptionsChange(options) {
                    multiSelect.find('option').remove();
                    parent.elements = [];

                    for (let i = 0; i < options.length; i++) {
                        let multiSelectOption = new MultiSelectOption(options[i], $('<option>').appendTo(multiSelect));
                        let tuple = multiSelectOption.getTuple();

                        parent.elements.push(multiSelectOption);
                    }
                }

                let subscription = items.subscribe(onOptionsChange);
                ko.utils.domNodeDisposal.addDisposeCallback(multiSelect[0], () => {
                    subscription.dispose();
                });
                onOptionsChange(items());
            }
        };
    }
}